import { Helmet } from "react-helmet";
import Footer from "../components/footer";
import Header from "../components/header";
import TopNavabr from "../components/topNavabr";

// import { useQuery } from "@tanstack/react-query";
// import { useNavigate } from "react-router-dom";
// import Spinner from "../components/spinner";
// import { BASE_URL } from "../data/baseURL";
// import { useScrollTop } from "../hook/useScrollTop";
import { Link } from "react-router-dom";
import careerImage from "../images/build-your-career.jpg";

// function getBgColor(status) {
//   console.log(status);
//   let btnColor = "bg-success";

//   if (status.toLowercase() === "closed") {
//     btnColor = "bg-danger";
//   } else if (status.toLowercase() === "apply now") {
//     btnColor = "bg-success";
//   } else if (status.toLowercase() === "full seat") {
//     btnColor = "bg-american-yellow";
//   } else if (status.toLowercase() === "coming soon") {
//     btnColor = "bg-primary";
//   }

//   return btnColor;
// }

export default function AfroInterns() {
  // const { data, isLoading, isError } = useQuery(
  //   ["build-your-career"],
  //   async () => {
  //     const response = await window.fetch(`${BASE_URL}/intern-all-job`);
  //     return await response.json();
  //   }
  // );

  // const navigate = useNavigate();

  // useScrollTop();

  // if (isLoading) {
  //   return <Spinner />;
  // }

  // if (isError) {
  //   throw new Error("Unable to load data");
  // }
  return (
    <>
      <Helmet>
        <title>AFRO || Career</title>
      </Helmet>
      <TopNavabr />
      <Header bannerBackground="image" staticImageURL={careerImage}>
        <div className="pt-7 pb-5 container">
          <div className="row header-background-image-size">
            <h1 className="fs-60 text-capitalize flex align-items-center col-12 col-md-6 gilroy-bold">
              Become AFRO Intern
            </h1>
            <p className="fs-22 gilroy-bold">From Learning to Earning</p>
            <div className="pt-5">
              <Link
                to="/career"
                // href="https://www.linkedin.com/company/afrosocial247/"
                // target="_blank"
                // rel="noreferrer"
                className="text-uppercase fs-16 header-button text-orange-ryb fw-900 text-decoration-none d-inline-block text-center"
              >
                Apply Now
              </Link>
            </div>
          </div>
        </div>
      </Header>
      <section className="container-fluid px-0" id="cv">
        <div className="container-fluid mt-5">
          <div className="ms-47 me-47 ">
            <div className="container mb-5">
              <div className="row">
                <div className="col-12 col-md-7 col-lg-8 fs-20">
                  <p>
                    <strong>The AFRO Internship Program</strong> is designed to
                    bring highly qualified and motivated students with diverse
                    backgrounds into the Organization to work on projects linked
                    to the Industry of your choice and your life career plans.
                    Its main goal is to give successful candidates the
                    opportunity to improve their technical and soft skills in an
                    international and corporate Organisation.
                  </p>
                  <p>
                    <strong>The Internship Program</strong> is open on an
                    on-going basis. Students enrolled at a fully accredited
                    degree program (Bachelor, Master, PhD) during the entire
                    duration of their internship can apply online. Selected
                    interns are on-boarded both remotely and in a hybrid form
                    until further notice.
                  </p>
                </div>
                <div className="col-12 col-md-5 col-lg-4">
                  <img
                    src="https://test.afro-group.net/public/uploads/index/afro1668194830.png"
                    alt=""
                    className="img-fluid rounded-2"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-american-yellow text-white">
          <div className="ms-47 me-47 pt-7 pb-7">
            <div className="text-white">
              <h2 className="fs-26 gilroy-bold text-dark">Who can apply?</h2>
              <h2 className="fs-24 gilroy-bold">
                Internships are open for students who:
              </h2>
              <ul className="fs-20">
                <li>
                  Are enrolled in a full-time degree program for the duration of
                  the internship in a field or discipline related to the work of
                  the AFRO Group;
                </li>
                <li>
                  Are available for a minimum internship duration of one month;
                </li>
                <li>
                  Have an excellent command of one of the two official languages
                  of the AFRO (English and Arabic) and working knowledge of, or
                  willingness to learn the other. Knowledge of other languages
                  used at the AFRO, such as French would be an advantage;
                </li>
                <li>Possess solid quantitative and IT skills;</li>
                <li>
                  Demonstrate excellent drafting and communication skills;
                </li>
                <li>
                  Are capable of working in a multicultural and international
                  team environment.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div style={{ backgroundColor: "#212529" }}>
          <div className="ms-47 me-47 pt-7 pb-7">
            <div className="text-center text-white">
              <h2 className="fs-22 gilroy-bold">
                When can I apply for an internship?
              </h2>
              <p className="fs-18">
                We recruit interns on an on-going basis and applications are
                accepted throughout the year. You can apply anytime via our
                online application platform
              </p>
              <Link
                to="/career"
                className={`text-decoration-none bg-american-yellow px-5 d-inline-block py-3 fs-14 text-white mb-5 text-uppercase border-0`}
              >
                Apply Now
              </Link>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
